import React, { useState, useEffect } from 'react'
import AboutYou from './AboutYou'

import $ from 'jquery'

import './App.css'

import Report from './report'
import JSZip from 'jszip'

import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'

import FileSelector from './FileSelector'

import Env from './Env'

const ROOT_URL = Env.ROOT_URL

export default function App(props) {
  const [sedds, setSedds] = useState([])
  const [hack, setHack] = useState(0)
  const forceUpdate = () => {
    setHack(hack + 1)
  }
  const [requiredFields, setRequiredFields] = useState([])
  const [validFields, setValidFields] = useState([])

  useEffect(() => {
    fetch(`${ROOT_URL}/valid_values.json`, { mode: 'cors', credentials: 'include' })
      .then(response => response.json())
      .then(({ required, valid }) => {
        setRequiredFields(required)
        setValidFields(valid)
      })
  }, [])

  const upload = (sedd, eventId, callback) => {
    const zip = new JSZip()
    zip.file('data_' + Date.now() + '.xml', sedd.rawXml)
    zip
      .generateAsync({
        type: 'blob',
        compression: 'DEFLATE'
      })
      .then(content => {
        const fd = new FormData()
        fd.append('import', content)
        fd.append('eventId', eventId)

        $.ajax({
          url: `${Env.ROOT_URL}/imports`,
          method: 'POST',
          data: fd,
          processData: false,
          contentType: false,
          statusCode: {
            400: () => {
              callback('AUTH ERROR', null)
            }
          },
          xhrFields: {
            withCredentials: true
          }
        })
          .done(function (data) {
            callback(null, data)
          })
          .fail(function (error) {
            callback(error, null)
          })
      })
  }

  const isFeedbackSubmitted = () => {
    const submitted = /feedbackSubmitted=true(;|$)/.test(document.cookie)
    console.log('checking if feedback is submitted', submitted)
    return submitted
  }

  const markFeedbackSubmitted = () => {
    console.log('creating cookie to mark feedback as submitted')
    document.cookie = 'feedbackSubmitted=true; expires=Fri, 31 Dec 9999 23:59:59 GMT";'
    //hack to force refresh
    setSedds(sedds)
  }

  const getValidationCount = () => {
    const regex = /validationCount=(.*?)(;|$)/
    if (!regex.test(document.cookie)) {
      console.log('validation count 0')
      return 0
    } else {
      console.log('validation count', regex.exec(document.cookie)[1])
      return parseInt(regex.exec(document.cookie)[1])
    }
  }

  return (
    <Router>
      <Switch>
        <Route path="/screen">
          <FileSelector
            {...{ sedds }}
            setSedds={setSedds}
            forceUpdate={forceUpdate}
            requiredFields={requiredFields}
            validFields={validFields}
          />
        </Route>

        <Route path="/report">
          {sedds.length === 0 && <Redirect to="/import" />}

          {sedds.map(sedd => {
            console.log('SEDD ERRORS', sedd.errors)
            if (!sedd.seddInfo) {
              return null
            }
            return (
              <React.Fragment key={sedd.seddInfo.labDataPackageId}>
                <AboutYou
                  root={Env.ROOT_URL}
                  visible={false}
                  markFeedbackSubmitted={markFeedbackSubmitted}
                />

                <Report
                  seddInfo={sedd.seddInfo}
                  rawXml={sedd.rawXml}
                  xmlDoc={sedd.xmlDoc}
                  errors={sedd.errors}
                  rootUrl={Env.ROOT_URL}
                  warnings={sedd.warnings}
                  requiredFields={requiredFields}
                  validFields={validFields}
                  uploadXml={upload.bind(null, sedd)}
                />
              </React.Fragment>
            )
          })}
        </Route>
        <Route path="/">
          <Redirect to="/screen" />
        </Route>
      </Switch>
    </Router>
  )
}
